<template>
  <div class="max-w-sm mx-auto">
    <form class="bg-white shadow-lg rounded px-4 pt-4 pb-8 m-2 border border-gray-200">
      <p class="text-center font-display text-xl text-pink-400 mb-6">Reports</p>
      <div class="mb-4 text-center">
        <a
          href="#"
          class="text-gray-800 border-b border-pink-500"
          @click.prevent="createReport(thirtyDaysAgo, today)"
        >Last 30 days</a>
      </div>
      <div class="mb-4 text-center">
        <a
          href="#"
          class="text-gray-800 border-b border-pink-500"
          @click.prevent="createReport(lastMonthFrom, lastMonthTo)"
        >{{ previousMonth }}</a>
      </div>
      <div class="mb-4 pb-6 text-center border-b-2 border-pink-400">
        <a
          href="#"
          class="text-gray-800 border-b border-pink-500"
          @click.prevent="createReport(taxDate, today)"
        >Since {{ taxDate | formatDate }}</a>
      </div>

      <div class="mb-4">
        <p class="text-center font-display text-xl text-pink-400 mb-6">Custom</p>

        <div class="text-white bg-red-400 p2 rounded text-center mb-3" v-if="check">
          <p>{{ error }}</p>
        </div>

        <div class="mb-3">
          <label for="amount">From:</label>
          <datetime
            input-class="border border-gray-400 cursor-pointer py-2 px-2 w-full"
            v-model="from"
            :max-datetime="today"
          ></datetime>
        </div>

        <div class="mb-3">
          <label for="amount">To:</label>
          <datetime
            input-class="border border-gray-400 cursor-pointer py-2 px-2 w-full"
            v-model="to"
            :max-datetime="today"
          ></datetime>
        </div>
      </div>

      <div class="text-right">
        <button
          class="bg-teal-400 hover:bg-teal-500 text-white py-2 px-4 rounded focus:outline-none"
          type="button"
          @click.prevent="createReport(from, to, true)"
        >Create</button>
      </div>
    </form>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "reports",
  data() {
    return {
      today: "",
      thirtyDaysAgo: "",
      lastMonthFrom: "",
      lastMonthTo: "",
      to: "",
      from: "",
      error: "",
      check: false,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      previousMonth: ""
    };
  },
  methods: {
    validateCustomReport() {
      if (!this.to && !this.from) {
        this.check = true;
        this.error = 'Both "From" and "To" fields must have dates';
        return false;
      }

      if (this.from > this.to) {
        this.check = true;
        this.error = '"From" date can\'t be after "To" date.';
        return false;
      }

      this.check = false;
      this.error = "";
      return true;
    },
    createReport(start, end, custom = false) {
      if (custom) {
        let valid = this.validateCustomReport();
        if (!valid) {
          return false;
        }
      }

      this.$store.dispatch("resetAllTransactions").then(() => {
        this.$store.dispatch("getTransactions", {
          userId: this.userId,
          startDate: start,
          endDate: end
        });
      });
    }
  },
  computed: {
    toFromValid() {
      if (this.from && this.to) {
        return this.from <= this.to;
      } else {
        return null;
      }
    },
    taxDate() {
      return this.$store.getters.settings.taxDate;
    },
    userId() {
      return this.$store.getters.settings.userId;
    }
  },
  watch: {
    toFromValid() {
      if (this.toFromValid === false) {
        this.check = true;
      } else {
        this.check = false;
      }
    }
  },
  created() {
    let today = moment()
      .utc()
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toISOString();

    this.today = today;

    let thirtyDaysAgo = moment()
      .utc()
      .subtract(30, "days")
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toISOString();

    this.thirtyDaysAgo = thirtyDaysAgo;

    let lastMonthFrom = moment()
      .utc()
      .subtract(1, "months")
      .startOf("month")
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toISOString();

    this.lastMonthFrom = lastMonthFrom;

    let lastMonthTo = moment()
      .utc()
      .subtract(1, "months")
      .endOf("month")
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toISOString();

    this.lastMonthTo = lastMonthTo;

    let month = moment()
      .utc()
      .subtract(1, "months")
      .month();

    this.previousMonth = this.months[month];
  },
  filters: {
    formatDate(isoDate) {
      if (!isoDate) {
        return "";
      }

      return new Date(isoDate).toLocaleDateString();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>